import { Text } from 'braid-design-system';
import { Children, isValidElement } from 'react';

import type { CardProps } from '../Card';

export const CardContent = ({
  loader,
  loading,
  isEmpty,
  emptyCardText,
  children,
  name,
}: Pick<
  CardProps,
  'loader' | 'loading' | 'isEmpty' | 'emptyCardText' | 'children' | 'name'
>) => {
  if (loading) {
    return <>{loader}</>;
  }

  if (isEmpty && emptyCardText) {
    return (
      <Text tone="secondary" data={{ automation: `${name}-empty-nudge` }}>
        {emptyCardText}
      </Text>
    );
  }

  const hasChildren =
    Children.toArray(children).filter(
      (child) =>
        isValidElement(child) ||
        (typeof child === 'string' && child.length > 0),
    ).length > 0;

  if (hasChildren) {
    return <div>{children}</div>;
  }

  return null;
};
